import { locationPageCrumbs } from "../structured-data-core";
import { serviceAreaSchema } from "./service-area";

export function getOklahomaCityStructuredData() {
  const url = "https://restorehair.com/locations/oklahoma/oklahoma-city/";
  const description =
    "Find out about your hair transplant options in Oklahoma City with RESTORE Hair. Over 20,000 procedures performed.";
  return [
    serviceAreaSchema("oklahoma-city", url, description),
    locationPageCrumbs(url, "Oklahoma City"),
  ];
}
